import gql from 'graphql-tag'

export const ADD_SCHEDULER_MUTATION = gql`
  mutation ($scheduler: AddSchedulerInput!) {
    addScheduler(scheduler: $scheduler) {
      id
    }
  }
`

export const GET_SCHEDULER_QUERY = gql`
  query ($limit: Int = 5, $offset: Int = 0, $where: scheduler_bool_exp) {
    scheduler(
      offset: $offset
      limit: $limit
      order_by: { created_at: desc }
      where: $where
    ) {
      id
      content
      pre_header
      type
      days
      header_code
      audience_id
      created_at
      updated_at
      subject
      unsubscribe_code
      enabled
      audience {
        name
      }
    }
    scheduler_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`

export const UPDATE_SCHEDULER_MUTATION = gql`
  mutation ($scheduler: UpdateSchedulerInput!) {
    updateScheduler(scheduler: $scheduler) {
      id
    }
  }
`

export const REMOVE_SCHEDULER_MUTATION = gql`
  mutation ($scheduler: RemoveSchedulerInput!) {
    removeScheduler(scheduler: $scheduler) {
      affected_rows
    }
  }
`

export const RUN_SCHEDULER_MUTATION = gql`
  mutation ($scheduler: RunSchedulerInput!) {
    runScheduler(scheduler: $scheduler) {
      success
    }
  }
`
